/**
 * The Events page grew out of two website page types — a dated list
 * ('calendar') and a weekly recurring one ('schedule'). Both still render the
 * combined page, so a site that has either keeps its URL and its menu entry.
 *
 * 'season_schedule' is a third layout over the same data (see
 * `isSeasonSchedulePageType`); it counts as the club's events page too, so a
 * site using it still replaces the built-in events link rather than gaining a
 * second one beside it.
 *
 * Keep in step with server/utils/eventsPage.js.
 */
export const EVENTS_PAGE_TYPES = ['events', 'calendar', 'schedule', 'season_schedule'];

export function isEventsPageType(pageType?: string | null): boolean {
  return EVENTS_PAGE_TYPES.includes(String(pageType || ''));
}

/**
 * A season — a fixed run of events over a term — reads differently from a
 * rolling list: what is next, how far through the run the club is, and every
 * night in it including the ones already played. Same data and the same row
 * components, in a layout that answers those questions instead.
 */
export function isSeasonSchedulePageType(pageType?: string | null): boolean {
  return String(pageType || '') === 'season_schedule';
}

export interface TenantNavItem {
  label: string;
  href: string;
  external?: boolean;
  pageType?: string | null;
}

/**
 * A club's own Events page, when it has one. It lists the club nights and the
 * regular week alongside the tournaments, so it replaces the built-in events
 * link rather than sitting beside it as a second, thinner answer.
 */
export function findEventsNavItem(navItems?: TenantNavItem[] | null): TenantNavItem | null {
  return (navItems || []).find((item) => !item.external && isEventsPageType(item.pageType)) || null;
}
